import React from "react";
import { Box, Card, LinearProgress, Typography } from "@mui/material";
import DashboardPanelHeader from "components/DashboardPanelHeader";
import { enterpriseTokens, overviewChartPalette } from "styles/theme";

const SafeManHours = ({ data }) => {
    const rows = [
        { label: "Formative team", value: Number(data?.safeManhours?.safeManhourOfFormativeTeam) || 0, color: overviewChartPalette.indigo },
        { label: "Contractor workforce", value: Number(data?.safeManhours?.safeManhoursOfContractor) || 0, color: overviewChartPalette.teal },
    ];
    const total = rows.reduce((sum, item) => sum + item.value, 0);

    return (
        <Card elevation={0} sx={{ height: "100%", border: `1px solid ${enterpriseTokens.lineSoft}`, borderRadius: "3px", overflow: "hidden" }}>
            <DashboardPanelHeader eyebrow="Workforce exposure" title="Safe Work Hours" subtitle="Compare recorded safe hours across project and contractor teams." />
            <Box sx={{ p: 1.5 }}>
                <Typography sx={{ fontSize: "30px", lineHeight: "36px", fontWeight: 700, color: enterpriseTokens.navy }}>{total.toLocaleString("en-IN")}</Typography>
                <Typography sx={{ fontSize: "11px", color: enterpriseTokens.muted }}>Total safe work hours</Typography>
                <Box sx={{ mt: 2, display: "grid", gap: 1.5 }}>
                    {rows.map((item) => {
                        const share = total > 0 ? (item.value / total) * 100 : 0;
                        return <Box key={item.label}>
                            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}>
                                <Typography sx={{ fontSize: "12px", fontWeight: 600, color: enterpriseTokens.slate }}>{item.label}</Typography>
                                <Typography sx={{ fontSize: "12px", fontWeight: 700, color: enterpriseTokens.navy }}>{item.value.toLocaleString("en-IN")} · {share.toFixed(0)}%</Typography>
                            </Box>
                            <LinearProgress variant="determinate" value={share} sx={{ height: 8, borderRadius: 0, backgroundColor: "#E2E8F0", "& .MuiLinearProgress-bar": { borderRadius: 0, backgroundColor: item.color } }} />
                        </Box>;
                    })}
                </Box>
            </Box>
        </Card>
    );
};

export default SafeManHours;
